import type { AppPage } from "../../../context/MonyawnContext.types";

export interface AboutExpert {
  role: string;
  purpose: string;
}

export interface AboutPageProps {
  RESUME_PATH: string;
  navigateToPage: (page: AppPage) => void;
  setNotice: (notice: { tone: "success" | "info"; message: string } | null) => void;
}

export const aboutExperts: AboutExpert[] = [
  {
    role: "Founder and Product Lead",
    purpose:
      "Keeps product direction anchored to user outcomes, evidence quality, and real career leverage.",
  },
  {
    role: "User Experience Lead",
    purpose:
      "Maintains a low-friction workflow so users can move from signal to action without cognitive overload.",
  },
  {
    role: "Narrative Strategy Lead",
    purpose:
      "Ensures generated story outputs stay credible, structured, and backed by user-provided proof.",
  },
  {
    role: "Discoverability and Growth Lead",
    purpose:
      "Aligns messaging, search intent, and distribution surfaces so qualified users can find and trust the product.",
  },
  {
    role: "Trust and Privacy Lead",
    purpose:
      "Protects local-first data handling and keeps governance controls explicit for every release.",
  },
];
